
import { format, startOfDay, endOfDay, startOfWeek, endOfWeek, startOfMonth, endOfMonth } from 'date-fns';
import { DateRangeOption } from '../types/task-operations-types';

/**
 * Calculate date range based on view mode
 */
export const getDateRange = (dateRange: DateRangeOption, currentDate: Date) => {
  if (dateRange === 'all') {
    return null;
  }
  
  const now = currentDate;
  
  if (dateRange === 'day') {
    return {
      startDate: format(startOfDay(now), 'yyyy-MM-dd'),
      endDate: format(endOfDay(now), 'yyyy-MM-dd')
    };
  } else if (dateRange === 'week') {
    return {
      startDate: format(startOfWeek(now, { weekStartsOn: 1 }), 'yyyy-MM-dd'),
      endDate: format(endOfWeek(now, { weekStartsOn: 1 }), 'yyyy-MM-dd')
    };
  } else if (dateRange === 'month') {
    return {
      startDate: format(startOfMonth(now), 'yyyy-MM-dd'),
      endDate: format(endOfMonth(now), 'yyyy-MM-dd')
    };
  }
  
  return null;
};
